import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1,
			clipPath: "url(#a)",
			children: [/* @__PURE__ */ _jsx("path", { d: "M17.5 19.375H4.375A1.875 1.875 0 0 1 2.5 17.5M5 .625a2.5 2.5 0 0 0-2.5 2.5V17.5a1.875 1.875 0 0 1 1.875-1.875h12.5A.624.624 0 0 0 17.5 15V1.25a.625.625 0 0 0-.625-.625H5Zm11.25 18.75v-3.75" }), /* @__PURE__ */ _jsx("path", { d: "M6.25 5.938v4.926a.624.624 0 0 0 .904.558l6.596-3.297-6.635-2.764a.624.624 0 0 0-.865.577v0Z" })]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0h20v20H0z",
				fill: "#fff"
			})
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cg%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221%22%20clip-path%3D%22url(%23a)%22%3E%3Cpath%20d%3D%22M17.5%2019.375H4.375A1.875%201.875%200%200%201%202.5%2017.5M5%20.625a2.5%202.5%200%200%200-2.5%202.5V17.5a1.875%201.875%200%200%201%201.875-1.875h12.5A.624.624%200%200%200%2017.5%2015V1.25a.625.625%200%200%200-.625-.625H5Zm11.25%2018.75v-3.75%22%2F%3E%3Cpath%20d%3D%22M6.25%205.938v4.926a.624.624%200%200%200%20.904.558l6.596-3.297-6.635-2.764a.624.624%200%200%200-.865.577v0Z%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h20v20H0z%22%20fill%3D%22%23fff%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
